"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractPrivateKeyStore = void 0;
class AbstractPrivateKeyStore {
}
exports.AbstractPrivateKeyStore = AbstractPrivateKeyStore;
//# sourceMappingURL=abstract-private-key-store.js.map